import { createI18n } from 'vue-i18n'

// element-plus 中的语言配置

// 自己的语言配置
import en from './en'  // 英语
import zhCn from './zh'   //中文
import it from './it'  // 西班牙语
import esAccessory from './esAccessory'  // 配件英语
import itlAccessory from './itlAccessory'  // 配件英语
// 语言配置整合
const messages = {
  en,
  zhCn,
  it,
  esAccessory,
  itlAccessory
}

// 创建 i18n
const i18n = createI18n({
  legacy: false, ///报错信息
  globalInjection:true,  // 全局模式，可以直接使用 $t
  locale: sessionStorage.getItem("lang") || 'en',
  messages: messages
})

export default i18n
